import React, { useEffect, useState } from 'react'
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import {
    Button,
    IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "src/stateManagement/redux";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';

interface Props {
    handleEditTag: any;
    handleDeleteTag: any;
}

export const FlagTable = ({ handleEditTag, handleDeleteTag }: Props) => {

    const { locationTags } = useSelector(
        (state) => state.location
    );
    
    const [filteredTags, setFilteredTags] = useState<any[]>([])

    useEffect(() => {
        const tagsForTable = locationTags?.filter((tag) => tag.alertType === "flag")||[]
        setFilteredTags(tagsForTable)

    }, [locationTags])




    const columns: GridColDef[] = [
        { field: "tagName", headerName: "tag", flex: 0.6 },
        { field: "variableName", headerName: "Variable", flex: 0.3 },
        { field: "comment", headerName: "Comentario", flex: 1 },
        {
            field: "actions",
            headerName: "",
            flex: 0.3,

            renderCell: (params) => {
                return (
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteTag(params.row.id)}
                        >
                            <DeleteForeverIcon fontSize="medium" />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEditTag(params.row.id)}
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                );
            },
        },
    ];

    const paginationModel = { page: 0, pageSize: 10 };

    return (
        <Grid size={12}>
            <DataGrid
                rows={filteredTags}
                columns={columns}
                initialState={{ pagination: { paginationModel } }}
                pageSizeOptions={[10, 20, 50, 100]}
                checkboxSelection={false}
                sx={{
                    border: 0,
                    mt: 2,
                    "& .MuiDataGrid-columnHeader": {
                        backgroundColor: "#316EBC",
                        color: "#fff",
                        fontWeight: "bold",
                    },
                }}
                getRowId={(row) => row.id}
            />
        </Grid>
    )
}

